"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewQuestion = exports.useCurrentQuestion = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var getQuestionText = function getQuestionText() {
  var currentQuestion = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentQuestion);
  if (!currentQuestion) {
    return {};
  }
  return {
    title: currentQuestion.title,
    subtitle: currentQuestion.subtitle
  };
};
var useCurrentQuestion = function useCurrentQuestion() {
  var _getQuestionText = getQuestionText(),
    title = _getQuestionText.title,
    subtitle = _getQuestionText.subtitle;
  var question = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentQuestion);
  var questionIndex = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentQuestionIndex);
  var selections = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectCurrentSelections);
  return {
    question: question,
    questionIndex: questionIndex,
    selections: selections,
    title: title,
    subtitle: subtitle
  };
};
exports.useCurrentQuestion = useCurrentQuestion;
var useViewQuestion = function useViewQuestion(questionIndex) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _questionnaireActions.setViewQuestion)(questionIndex));
  }, [questionIndex]);
};
exports.useViewQuestion = useViewQuestion;